import type { BlockId, LessonScreenData } from "../../lessonTypes";
import BlockRenderer from "../blocks/BlockRenderer";

interface LessonScreenProps {
    screen?: LessonScreenData;
    onBlockComplete: (blockId: BlockId) => void;
    onAnswer?: (isCorrect: boolean) => void;
}

// One screen of a lesson: its blocks, top to bottom
const LessonScreen = ({ screen, onBlockComplete, onAnswer }: LessonScreenProps) => {
    if (!screen) return null;

    return (
        <div className="w-full max-w-3xl mx-auto px-4 py-8">
            <div className="flex flex-col gap-6">
                {screen.blocks.map((block, index) => (
                    <BlockRenderer
                        key={block.id ?? index}
                        block={block}
                        onComplete={() => {
                            // Blocks without an id can't be tracked
                            if (block.id !== undefined) onBlockComplete(block.id);
                        }}
                        onAnswer={onAnswer}
                    />
                ))}
            </div>
        </div>
    );
};

export default LessonScreen;